import { Row, Col} from 'antd';
import * as React from 'react';

import { TaxonomyDataService } from 'src/app/general/taxonomies/form/taxonomy-form.data';
import { DataLocalService } from 'src/core/services/data-local.service';

interface TaxonomyTagsRendererProps{
	taxonomyDefinitionName: string | null;
	colSpan: number;
	vertical?: boolean;
	setBusy: (isBusy: boolean) => void;
	model:{[id:string]: any};
	propName: string;
	onLoadTaxonomies?: (isAny: boolean) => void;
}
interface TaxonomyTagsRendererState{
	tags: TaxonomyTagSummary[],
	tax_name: string
}

export class TaxonomyTagsRenderer extends React.Component<TaxonomyTagsRendererProps, TaxonomyTagsRendererState>{
	tagsDataService: DataLocalService<TaxonomyTagSummary>;

	constructor(props: TaxonomyTagsRendererProps) {
		super(props);

		this.state = {
			tags: null,
			tax_name: null
		};
	}

	componentDidMount() {
		this.loadTagsData(this.props.taxonomyDefinitionName);
	}

	private async loadTagsData(jsonSchemaDefinitionName: string): Promise<void> {
		this.props.setBusy(true);
		const taxonomyDataService = TaxonomyDataService.make();
		this.tagsDataService = new DataLocalService([]);
		this.setState({ tags: null });

		taxonomyDataService.addFilter('jsonSchemaDefinitionName', 'eq', jsonSchemaDefinitionName);
		taxonomyDataService.addSorting('id', 'asc', true);
		taxonomyDataService.pageSize = 1;

		taxonomyDataService.load(query => query)
			.then((items) => {
				const taxonomy = items[0];
				const name=taxonomy.dynamicProperties.displayName.en;
				const tags = taxonomy.dynamicProperties.taxonomyTags.map((m) => {
					const languages = Object.getOwnPropertyNames(m.displayName);
					let index = languages.indexOf("en");
					if (index === -1) {
						index = 0;
					}
					const language = languages[index];

					return {
						id: m.id,
						displayName: m.displayName[language]
					};
				});
				this.setState({ tax_name: name, tags: [...tags] });
			});

		this.props.setBusy(false);

		this.tagsDataService.setQuery(() => {
			const keywords = this.tagsDataService.searchKeywords;
			let tags = this.state.tags || [];
			if (keywords) {
				tags = tags.filter(m => m.displayName.indexOf(keywords) > -1);
			}

			return tags;
		});
	}

	private getTagsCols(tags: TaxonomyTagSummary[], maxPerCol: number){
		const length=tags.length;
		const tagsCols=[];
		let idx=-1;
		for(let i=0;i<length; i++){
			if(i%maxPerCol==0){
				tagsCols.push([]);
				idx++;
			}
			tagsCols[idx].push(tags[i]);
		}
		return tagsCols;
	}

	render(){
		const {tax_name, tags}=this.state;
		const {colSpan, vertical, model, propName, onLoadTaxonomies}=this.props;
		if(tags && model[propName]){
			const filteredTags=tags.filter((tag)=>model[propName].indexOf(tag.id) > -1);
			if(onLoadTaxonomies)
				onLoadTaxonomies(filteredTags.length>0);
			if(filteredTags.length>0){
				const tagsCols=this.getTagsCols(filteredTags, 15);
				const cols=tagsCols.map((tagCol)=>{return(
					<Col span={colSpan}>
						{tagCol.map((tag)=>{return(
						<Row>
							{tag.displayName}
						</Row>
					)})}
					</Col>)});

				if(vertical){
					return <Col>
						<Row>
							<span style={{fontWeight:"bold"}}>{tax_name+": "}</span>
						</Row>
						<Row style={{padding:5}}>
							{...cols}
						</Row>
					</Col>
				}
				else{
					return <Row type="flex" justify="start">
						<Col span={colSpan}>
							<span style={{fontWeight:"bold"}}>{tax_name+": "}</span>
						</Col>
						{...cols}
					</Row>
				}
			}
			else{
				return null;
			}
		}
		else{
			return null;
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/bookings/search/results/search-results-taxonomy.view.tsx